/**************************************************
 * Nombre:       Dialogo_Politicas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Checkbox, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Suscripcion from "../Formularios/Formulario_Suscripcion";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_color.png'
import {CheckCircle} from '@mui/icons-material'
import {useState} from "react";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {limpiarCelular} from "../../Modulo_formularios/Funciones/limpiarCelular";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politica from "./Dialogo_Politica";
import {enviarMensaje} from "../../CodCliente/enviarMensaje";

const Dialogo_Suscripcion = ({cerrar, realizado, datos}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Cargador, Avisos, nuevoAviso, iniciarCarga, terminar, cerrarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: cerrar
    })
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politica})
    const [acepta, setAacepta] = useState(true)


    let subirDatos = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga('Estamos registrandote...')

        entidad.celular = limpiarCelular(entidad.celular)


        let dox = await guardarDoc('suscriptores', entidad)
        if (dox.res) {
            await enviarMensaje({entidad: entidad})
            terminar({aviso: "Registro exitoso"})
        } else {
            terminar({aviso: "Algo inesperado sucedio, intentalo nuevamente", variante: 'error'})
        }

    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}} sx={{px: 2, color: '#fff'}}>

            <Cargador/>

            <Avisos/>

            <Dialogo/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <img src={logo} width={150} height={'auto'} alt={'logo'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                <Typography sx={{textAlign: 'center'}}>Estas aun un paso de lograrlo, completa los campos y disfruta de
                    los beneficios de ser parte
                    de la comunidad <span style={{fontWeight: 800}}>VIP</span> </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                <Formulario_Suscripcion props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2, px: 1,}}>


                <Typography sx={{fontSize: 14, lineHeight: 1.1, color: '#ffffff90'}}>
                    <Checkbox checked={acepta} onChange={() => setAacepta(!acepta)} sx={{p: 0.5}}/>
                    Acepto la <span
                    onClick={() => abrir()}
                    style={{textDecoration: 'underline', cursor: 'pointer'}}>política de tratamiento de datos</span>
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3, mb: 3}}>
                <Button
                    onClick={() => subirDatos()}
                    disabled={!acepta}
                    startIcon={<CheckCircle/>}
                    sx={{
                        py: 1,
                        px: 3,
                        borderRadius: 8,
                        background: 'rgba(255, 255, 255, 0.20)',
                        color: '#fff',
                        fontWeight: 400,
                        fontSize: 14
                    }}
                >
                    HACER PARTE AHORA
                </Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Suscripcion